export type CurrencyDisplayStyle = 'narrow' | 'symbol';

export const formatCurrency = (
  amount: number | string | undefined | null,
  currency: string = 'GHS',
  display: CurrencyDisplayStyle = 'narrow'
) => {
  const num = Number(amount) || 0;
  try {
    if (currency === 'GHS') {
      const options: Intl.NumberFormatOptions = {
        style: 'currency',
        currency: 'GHS',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
        currencyDisplay: display === 'narrow' ? 'narrowSymbol' : 'symbol'
      };
      return new Intl.NumberFormat('en-GH', options).format(num);
    }
    return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(num);
  } catch (e) {
    return `${currency === 'GHS' ? '₵' : ''}${num.toLocaleString()}`;
  }
};
